<template>
    <div  class="spviewhome">
        <div id="toolbar" class="tool_bar" ref="tool_bar">
              <ul  class="ul_tools ">
                  <li  v-if="pop==0">
                  <span id="collect_expend" class="icon-jiantou_liebiaoxiangzuo zhedie-button iconfontcolor"  @click.stop="btn('collect_expend')"> </span>
                  </li>
              </ul>
            <ul class="ul_tools " v-for="item in parmObj">
                  <li  v-if="!item.hidden && pop==0">

                      <el-tag  style="float:left;margin-top:2Px;height:30px;font-size: 9px;"> {{ item.title }}</el-tag>
                      <el-date-picker   v-if="item.type=='date'" v-model="item.value" :ref="item.name"   @focus="selectFocus(item)" :type="item.datatype" :value-format="item.format"  :format="item.format" size="small" :placeholder="$t('form_date')" style="margin-top:2px;width:130px;" >
                      </el-date-picker>

                      <el-input v-if="item.type=='text'" class="parm_item" v-model="item.value" @focus="inputfocus" :placeholder="$t('form_please_enter')"  size="small" style="margin-top:2px;width:130px;" :style="item.style"/>
                      <el-select v-if="item.type=='select' " v-model="item.value"   :ref="item.name" @change="onSelectedItem(item)" :disabled="item.readonly"  class="parm_item" filterable @focus="selectFocus(item)" size="small" :style="item.style"  >
                          <el-option
                                  v-for="item1 in parmData[item.dsname]"
                                  :key="item1.id"
                                  :label="item1.name"
                                  :value="item1.id"

                          ></el-option>
                      </el-select>

                      <el-select v-if="item.type=='tree'"
                                 v-model="item.value"
                                 name="item.name"
                                 :placeholder="$t('form_please_select')"
                                 size="small"
                                 class="parm_item"
                                 :ref="`${item.name}_select`"
                                 filterable
                                 :filter-method="filterOption"
                                 @change="onSelectedItem(item)"
                                 @focus="selectFocus(item)"
                      >
                          <el-option
                                  :value="item.value"
                                  :label="item.label"
                                  disable
                                  style="height: auto; padding: 0;font-size: 12px;font-family: 'Arial', sans-serif;font-weight: normal;"
                          >

                              <el-tree   :data="parmTreeData[item.name]" :props="item.props"  :ref="`${item.name}_tree`" :filter-node-method="filterTreeNode"
                                         :element-loading-text="$t('tips_data_loading_in_progress')"
                                         node-key="id" highlight-current    @node-click="(data) => treeNodeClick(data, item)">
                              </el-tree>
                          </el-option>
                      </el-select>


                  </li>
              </ul>
            <ul class=" ul_tools ">

                <li v-if="pop==0" v-for="item in pageList"
                    :key="item.index"
                    :title="item.title"
                    :id="item.name"
                    @click.stop="btn(item.name) ">
                    <el-divider v-if="item.class=='divider'" class="iconfont icon-button " direction="vertical"></el-divider>
                    <span v-else :class="item.class +' '+ item.pic"  :style="item.style"></span>
                </li>
            </ul>
            <ul class=" ul_tools " v-if="editState==-2">

                <li v-for="item in opList"
                    :key="item.index"
                    :title="item.title"
                    :id="item.name"
                    @click.stop="btn(item.name) ">
                    <el-divider v-if="item.class=='divider'" class="iconfont icon-button " direction="vertical"></el-divider>
                    <span v-else :class="item.class +' '+ item.pic"  :style="item.style"></span>
                </li>
            </ul>
            <ul class=" editbutton ul_tools " v-if="editState>=0">

                <li v-for="item in opList1"
                    :key="item.index"
                    :title="item.title"
                    :id="item.name"
                    @click.stop="btn(item.name) ">
                    <el-divider v-if="item.class=='divider'" class="iconfont icon-button " direction="vertical"></el-divider>
                    <span v-else :class="item.class +' '+ item.pic"  :style="item.style"></span>
                </li>
            </ul>
            <ul class="ul_tools ">

                <li v-for="item in pageList1"
                    :key="item.index"
                    :title="item.title"
                    :id="item.name"
                    @click.stop="btn(item.name) ">
                    <el-divider v-if="item.class=='divider'" class="iconfont icon-button " direction="vertical"></el-divider>
                    <span v-else :class="item.class +' '+ item.pic"  :style="item.style"></span>
                </li>
            </ul>
            <ul class="ul_tools ">

                <li v-for="item in cusBtn.l"
                    :key="item.index"
                    :title="item.title"
                    :id="item.name"
                    @click.stop="cusBtnClk(item.name) ">
                    <el-divider v-if="item.class=='divider'" class="iconfont icon-button " direction="vertical"></el-divider>
                    <span v-else class="iconfont icon-button" >{{item.title}}</span>
                </li>
            </ul>

        </div>

<div  class="content">


    <div  class="sp_tab__view"  >

        <el-tabs :value="activeTab" type="border-card"
                 class="el-tabs-card"  @tab-click='tabClick'  @tab-remove="removeTab" >
            <el-tab-pane v-for="(item, index) in spTabs" :key="item.name" :label="item.title"  :name="item.name" :closable='item.closable'>
                <div  class="component" >
                    <component :is='item.content' :ref="item.name"  @deldetail="deleteImportDetail" @getargData="loadargs" @newView="addTab" @cellClick="spreadClick" @load="initTab(item.name)"  ></component>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>



        </div>
        <input type="file" style="display:none"  name="upload_file" ref="upload_file" id="upload_file" @change="importFile"/>


        <div class="">
             <mydialog ref="mydialog" ></mydialog>
        </div>
    </div>
</template>
<script>
    import * as jUtil from '@/utils/gcExcelJs.js';
    import mydialog from "@/components/dialog"; // dialog
    import menu from '../res/menu.js';
    import spc from "../res/spreadBase";
    import {delServiceConfig} from "../../msgCenter/busyConfig/api";

    export default {
        name: "spread",
        components: {
            spc,
            mydialog
        },
        props: {


        },
        watch: {

        },
        data() {
            return {
                activeTab: '',
                pop:0,
                spTabs: [],
                tabIndex: 0,
                parmObj: {},
                parmData:{},
                argData:{},
                parmTreeData:[],
                tabParm:{},
                dsData:{},
                editState:-1,
                parmLoad:0,
                importFileName:'',
                spreadNS: GC.Spread.Sheets,
                cusFn:{},
                cusBtn:{},
                    pageList: {
                        shujuchaxun:{name:'chaxun-chaxun',title:this.$t('report_query'),data:1,style:'font-size:20px',pic:' icon-zhihang',class:'font-button iconfontcolor'}},
                opList:{
                        divider_p: {class: 'divider'}
                       ,new:{name:'file-new',title:this.$t('report_new'),data:1,style:'padding:4px ;font-size:26px',pic:'icon-wenjian1',class:'font-button iconfontcolor'}
                        },
                opList1:{ template:{name:'file-template',title:this.$t('report_import_template'),data:1,style:'padding:1px 1px;font-size:32px',pic:'icon-daoru',class:'font-button iconfontcolor'}
                        ,shanchu:{name:'file-delete',title:this.$t('button_delete'),data:1,style:'font-size:22px',pic:'icon-shanchu',class:' font-button iconfontcolor'}
                   ,save:{name:'file-save',title:this.$t('button_save'),data:1,style:'padding:2px 1px;font-size:28px',pic:'icon-autosave',class:' font-button iconfontcolor'}},
                pageList1: {
                divider_p: {class: 'divider'},
                    saveas: {
                        name: 'page-saveas',
                        title: this.$t('report_save_as'),
                        data: 1,
                        style: 'padding:2px;font-size:32px',
                        pic: 'icon-excel',
                        class: 'font-button iconfontcolor'
                    },
                    print: {
                        name: 'page-print',
                        title: this.$t('report_print_preview'),
                        data: 1,
                        style: 'font-size:24px',
                        pic: 'icon-dayinyulan',
                        class: 'font-button iconfontcolor'
                    },
                    zoom_in: {
                        name: 'page-zoom_out',
                        title: this.$t('report_magnify'),
                        data: 1,
                        style: 'padding:0 0 0 2px;font-size:28px',
                        pic: 'icon-suofangda',
                        class: 'font-button iconfontcolor'
                    },
                    zoom_out: {
                        name: 'page-zoom_in',
                        title: this.$t('report_reduce'),
                        data: 1,
                        style: 'padding:2px;font-size:28px',
                        pic: 'icon-suofangxiao',
                        class: 'font-button iconfontcolor'
                    },
                    freeze: {
                        name: 'page-freeze',
                        title: this.$t('report_lock'),
                        data: 1,
                        style: 'padding:0 0 0 2px;font-size:24px',
                        class: 'icon-button iconfont icon-freeze'
                    }
                },
            }
        },
        mounted() {

            $("#toolbar").find(".el-color-picker__trigger").css("border", "0px");
            $("#toolbar").find(".el-color-picker__icon").removeClass("el-icon-arrow-down");
            window.addEventListener("resize", this.onResize);
            this.onResize();
            this.addTab();
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.onResize);
        },
        methods: {

            onResize() {

                $(".sp_tab__view").height($(".spviewhome").height() * 1 - $("#toolbar").height() * 1 );
                $(".sp_tab__view").width($(".spviewhome").width() );
                $(".component").height($(".sp_tab__view").height() * 1 - 36);
                $(".component").width($(".sp_tab__view").width()*1);
                this.spTabs.forEach((tab, index) => {if(this.$refs[tab.name]) this.$refs[tab.name][0].onResize();});

            },
            onOpen(n){
                this.onResize();
                this.pop=1;
                this.addTab(n.parm);
                if(n.hasOwnProperty('btn')) {
                   // this.cusFn=n.btn.f;
                    n.btn.l=Object.assign({divider_p: {class: 'divider'}},n.btn.l);
                    this.cusBtn =n.btn;
                }
            },
            addTab(n) {
                let tabName="";
                if (n==null )
                {
                    tabName = 'spTab_0' ;
                    this.spTabs.push({
                        title: "",
                        name: tabName,
                        content: "spc",
                        closable: true,
                        editState:-1,
                        data: null
                    });
                    this.activeTab = tabName;
                    this.editState=-1;
                    this.setButtonState(-1);
                }else {
                        this.removeTab("spTab_0");
                    let find=-1;
                        if (!n.hasOwnProperty('liancha') && !n.importType ) {
                            this.spTabs.forEach((tab, index) => {
                                if (tab.data.fid === n.fid && tab.data.importid == n.importid) {
                                    this.tabClick(tab);
                                    find = index;
                                }
                            });
                        }
                      if (find==-1){
                            this.tabIndex++;
                            tabName = 'spTab_' + this.tabIndex;
                            this.spTabs.push({
                                title: n.filename,
                                name: tabName,
                                content: "spc",
                                closable: true,
                                editState:n.editState,
                                importid:n.importid,
                                importType:n.importType,
                                data: n
                            });
                          this.activeTab = tabName;
                          this.editState=n.editState;
                          this.setButtonState(this.editState);
                      }

                }


            },
             tabClick(tab){
                this.getArgsObj(this.activeTab);

                    this.activeTab = tab.name;
                    let p = this.tabParm[tab.name];
                    this.parmData = p.parmData;
                    this.argData = p.argData;
                    this.parmObj = p.parm;
                    this.editState=p.editState;
                    this.setParmDetail();
                    this.setButtonState(this.editState);

            },

            resetData(){
                this.tabIndex=0;
                this.spTabs=[];

            },
            tabDataLoaded(n,parm)
            {
                if ((n.data.hasOwnProperty('arg') && n.data.arg.hasOwnProperty('liancha') )|| n.data.importType ) {
                    parm.parmData = this.parmData;
                    parm.argData=this.argData;
                }
                parm.editState=n.editState;
                this.tabParm[n.name] = parm;
                this.parmData =parm.parmData;
                this.argData =parm.argData;
                this.parmObj = parm.parm;
                this.setParmDetail();
                this.setButtonState(n.editState);
                if (n.data.importType) this.openImportFile();
             },

            setPage(op){
                this.$refs[this.activeTab][0].setPage(op);
            },
            initTab(targetName){
                let _this=this;
                this.onResize();
                let tabs = this.spTabs;
                tabs.forEach((tab, index) => {
                    if (tab.name === targetName) {
                        this.$refs[targetName][0].onOpen((res)=> {
                            this.loadReportData(tab);

                        });
                    }
                });
            },
            removeTab(targetName) {//--------------这是关闭tab页的
                let tabs = this.spTabs;
                let activeName = this.activeTab;
                if (activeName === targetName) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === targetName) {
                            let nextTab = tabs[index + 1] || tabs[index - 1];
                            if (nextTab) {
                                activeName = nextTab.name;
                            }
                        }
                    });
                }
                delete this.tabParm[targetName];
                this.spTabs = tabs.filter(tab => tab.name !== targetName);
                this.activeTab = activeName;
                this.setButtonState(1);
            },

            btn(id) {
                if (id == undefined) return;
                let id_family = id.split("-");
                let sid = id_family[1];
                switch (id_family[0]) {
                    case 'chaxun':
                        let n=this.tabParm[this.activeTab].rpt;
                        n.data.arg=this.getArgsObj(this.activeTab);
                        if (n.data.arg.hasOwnProperty('valid'))
                        { this.$refs.mydialog.showDialog({type:"error",text:this.$t('report_parameter_error'),info:n.data.arg.valid});
                            delete n.data.arg.valid;
                            return false;
                        }
                        this.loadReportData(n,true);

                        break;
                    case 'file':
                        this.setFile(sid);
                        break;
                    case 'page':
                        this.$refs[this.activeTab][0].setPage(sid);
                        break;

                    case 'collect_expend':
                        if ($("#collect_expend").hasClass("icon-jiantou_liebiaoxiangzuo")) {

                            $("#collect_expend").removeClass("icon-jiantou_liebiaoxiangzuo");
                            $("#collect_expend").addClass("icon-jiantou_liebiaoxiangyou");
                            this.$parent.btn('collect');
                        } else {
                            $("#collect_expend").removeClass("icon-jiantou_liebiaoxiangyou");
                            $("#collect_expend").addClass("icon-jiantou_liebiaoxiangzuo");
                            this.$parent.btn('expend');
                        }

                        break;

                    default:
                        break;
                }
            },
            cusBtnClk(a){
                this.cusBtn.f(a);
            },
            setFile(op) {
                switch (op) {
                    case 'new':
                        {
                            this.getArgsObj(this.activeTab);

                        let p = this.tabParm[this.activeTab];
                        let n=p.rpt.data;
                        n.importid=0;
                        n.editState=0;
                        n.filename=this.$t('report_new');
                        n.importType = true;
                        this.addTab(n);}
                        break;
                    case 'template': {
                        // this.getArgsObj(this.activeTab);
                        //
                        // let p = this.tabParm[this.activeTab];
                        // let n = p.rpt.data;
                        // n.importid = 0;
                        // n.editState = 0;
                        // n.filename = '导入';
                        // n.importType = true;
                        this.openImportFile();
                        // this.addTab(n);

                        }
                        break;
                    case 'delete':
                        this.deleteImportData();
                        break;

                    case 'save':
                        let n=this.tabParm[this.activeTab].rpt;
                        n.data.arg=this.getArgsObj(this.activeTab);
                        if (n.data.arg.hasOwnProperty('valid'))
                        { this.$refs.mydialog.showDialog({type:"error",text:this.$t('report_parameter_error'),info:n.data.arg.valid});
                           delete n.data.arg.valid;
                        return false;
                        }
                        let spreadData=n.data;
                        spreadData.template = this.$refs[this.activeTab][0].spread.toJSON();
                        spreadData.editIds=this.$refs[this.activeTab][0].editIds;
                        if (n.importType) {
                            spreadData.filename=this.importFileName.substr(0,this.importFileName.indexOf('.'));
                            this.saveImportData(spreadData,true);
                        }
                        else
                        {
                            this.saveImportData(spreadData,false);
                        }
                        break;

                    default:
                        break;
                }
            },
            setButtonState(type) {
                if (type==0)
                    $(".editbutton").removeClass("font-disable");
                else
                    $(".editbutton").addClass("font-disable");
            },
            inputfocus(a) {
                a.target.select();
            },

            filterOption(value) {
                //  if (!value) return true;
                let treename = `${this.focusObj.name}_tree`;
                this.$refs[treename][0].filter(value);
            },
            selectFocus(item) {
                this.focusObj = item;
            },

            onSelectedItem(item) {
                let _this=this;

                if (item.hasOwnProperty('trigger')) {
                    let parmName = item.trigger;
                    this.parmObj.forEach((ob, ind) => {
                        if (ob.name == parmName) {
                            let cond = ob.option.cond;
                            let sds = ob.option.sds;
                            let tds = ob.dsname;
                            let sname =ob.hasOwnProperty('sname')?ob.sname:'';
                            this.parmData[tds]=[];
                            ob.value ="";
                            let i=0;
                            let li={};
                            _this.parmData[sds].forEach((data, index) => {
                                if (data[cond] == item.value) {
                                    let s_name = data.hasOwnProperty(sname)?data[sname]:'';
                                    if (ob.option.hasOwnProperty('id')) {
                                        let id = ob.option.id;
                                        let name = ob.option.name;
                                        if (i==0) ob.value = data[id];

                                        if (!li.hasOwnProperty(data[id]))
                                        {_this.parmData[tds].push({'id': data[id], 'name': data[name],'sname':s_name});
                                         li[data[id]]='';
                                        }
                                    } else {
                                        if (i==0) ob.value = data['id'];
                                        if (!li.hasOwnProperty(data['id']))
                                        {
                                            _this.parmData[tds].push({'id': data['id'], 'name': data['name'],'sname':s_name});
                                            li[data['id']]='';
                                            }
                                    }
                                    i++;
                                }

                            });

                            if (ob.hasOwnProperty("all"))  _this.parmData[tds].unshift({'id':'%', 'name': ob.all,'sname':'all'});
                            if(ob.hasOwnProperty("trigger")) _this.onSelectedItem(ob);
                        }
                    });
                }
            },



            //关闭弹窗
            spreadClick(a){
                if (this.focusObj){
                    let name=this.focusObj.name;
                    if (this.focusObj.type=='tree') name=this.focusObj.name+'_select';
                    //let ref=this.$refs.[name];
                    if (this.focusObj.type=="date")
                        this.$refs[name][0].hidePicker()
                    else
                        this.$refs[name][0].blur();
                }
                this.focusObj=null;
            },
            filterTreeNode(value, data) {
                if (!value) return true;
                if (data.name == undefined) {
                    return data.label.indexOf(value) !== -1;
                } else {
                    return data.name.indexOf(value) !== -1;
                }
            },
            setParmDetail() {
                let _this = this;
                $.each(this.parmObj, function (key, item) {
                    let name = item.name;
                    if (_this.argData.hasOwnProperty(name)) item.value = _this.argData[name];
                    let db = item.dsname ? item.dsname : item.name;
                    if (item.type == "select" && _this.argData.hasOwnProperty('update') && _this.argData.update==1)
                    {
                        _this.parmData[db]=[];
                        _this.parmData[db].push({id:_this.argData[name],name:_this.argData[name+'_t']});

                    }
                    if (item.type == "tree") {
                        let db2=item.dschild?_this.parmData[item.dschild]:null;
                        _this.parmTreeData[name] = _this.setTreeItem(_this.parmData[db],db2);
                    }
                    if (item.type == "select" && item.hasOwnProperty("all") && _this.parmData[db].length>0 && _this.parmData[db][0].id!='%')  _this.parmData[db].unshift({'id':'%', 'name': item.all});

                });

            },



            setTreeItem(data,data1){
                let _this=this;
                let newdata=[];
                $.each(data, function (key, item) {
                    if (data.filter(obj => obj.id==item.pid).length==0)
                    {  item['children']=[];
                        item=_this.setTreeChild(item,data,data1);
                        newdata.push(item);}
                });
                return newdata;
            },
            setTreeChild(p,data,data1){
                let _this=this;
                let childItem=data.filter(obj => obj.pid==p.id)
                if (childItem.length==0 && data1!=null) p=this.setTreeChild2(p,data1);
                $.each(childItem, function (key, item) {
                    item['children']=[];
                    item=_this.setTreeChild(item,data,data1);
                    p.children.push(item);
                });
                return p;
            },
            setTreeChild2(p,data1){
                let _this=this;
                let childItem=data1.filter(obj => obj.pid==p.id)
                $.each(childItem, function (key, item) {
                    item['children']=[];
                    p.children.push(item);
                });
                return p;
            },
            treeNodeClick(data, item) {
                item.value = data.id;
                item.label = data.name;
                if (data.hasOwnProperty('type')) item.typeValue=data.type;
                let selectTree = `${item.name}_select`;
                this.$refs[selectTree][0].blur();
            },

            getArgsObj(tab) {
                let _this = this;
                let oldarg=this.tabParm.hasOwnProperty(tab)?this.tabParm[tab].argData:this.argData;//JSON.parse(JSON.stringify(this.argData));

                let args = {};
                $.each(this.parmObj, function (key, data) {
                    let db = data.dsname ? data.dsname : data.name;
                    if (data.type == "select" && _this.parmData[db]) {
                        let op = _this.parmData[db].filter((item) => {
                            return item.id === data.value
                        })
                        args[data.name] = op.length > 0 ? op[0].id : data.value;
                        args[data.name + "_t"] = op.length > 0 ? op[0].name : "";
                        args[data.name + "_st"] = op.length > 0 && data.hasOwnProperty('sname')? op[0].sname : "";
                    }else if(data.type == "select" && data.hidden){
                        args[data.name]=oldarg[data.name];
                        args[data.name+"_t"]=oldarg[data.name+"_t"];
                        args[data.name+"_st"]=oldarg[data.name+"_st"];
                    }
                    else if(data.type=="tree" && _this.parmData[db])
                    {

                        args[data.name]=data.value;
                        args[data.name+"_t"]=data.label;
                        if (data.hasOwnProperty("typeValue")) args[data.name+"_type"]=data.typeValue;
                    }
                    else if (data.type == "date") {
                        if (data.value == null || data.value == undefined) data.value = new Date();

                        args[data.name] = data.value;
                        //java 后台shezhi data.name+"_s|_e"
                        if (data.datatype == 'month') {

                            args[data.name + "_s"] = data.value + "-01";
                            var d = data.value.split("-");
                            var lastDay = new Date(d[0], d[1], 0).getDate();
                            args[data.name + "_e"] = data.value + "-" + lastDay;
                        } else {
                            let nd = new Date(data.value);
                            const year = nd.getFullYear();
                            const month = String(nd.getMonth() + 1).padStart(2, '0'); // 月份补0，使其始终为两位数
                            args[data.name + "_s"] = `${year}-${month}-01`;
                            let lastDay = nd.getDate();
                            args[data.name + "_e"] = `${year}-${month}-${lastDay}`;
                            if (data.days)
                            {
                                let days=_this.getDaysBetween(data.value,args[data.days.sdate]);
                                if(days>data.days.day)
                                    args['valid']=args['valid']?args['valid']+','+this.$t('report_the_start_and_end_date_difference_exceeds_days',{num:data.days.day}):(this.$t('report_the_start_and_end_date_difference_exceeds_days',{num:data.days.day}));

                            }
                        }
                    } else
                        args[data.name] = data.value;
                        if (data.hasOwnProperty("valid") && args[data.name]=='' )
                        { if (args.hasOwnProperty("valid"))
                            args['valid']=args['valid']+','+ data.title+this.$t('report_not_chosen');
                        else
                            args['valid']=data.title+this.$t('report_not_chosen');
                        }
                });
                args.parmLoad=this.parmLoad;
                this.tabParm[tab].argData=args;
                this.argData=args;
                return args;
            },
            getDaysBetween(dateString1, dateString2) {
                // 创建Date对象
                let startDate = new Date(dateString1);
                let endDate = new Date(dateString2);

                // 计算毫秒差值
                let diffMilliseconds = Math.abs(endDate - startDate);

                // 将毫秒差值转换为天数
                let diffDays = Math.floor(diffMilliseconds / (1000 * 60 * 60 * 24));

                // 返回天数差异
                return diffDays;
            },
            loadargs(callback){
                let res=this.getArgsObj(this.activeTab);
                callback(res);
            },

            async  saveImportData(n,type) {
                let _this=this;
                let res = await jUtil.saveImportData(n);
                if (res.code==1) {
                    this.$message.success(this.$t('report_saved_successfully_please_verify'));
                    if (n.importid==0) this.removeTab(_this.activeTab);
                    this.$emit("uphis",res.data,0);
                }
                else {
                    this.$refs.mydialog.showDialog({type:"error",text:this.$t('report_data_processing_failed')+'!('+res.message+")",info:res.error});
                }
            },
            //deleteimportData
            async  deleteImportData() {

                let _this=this;
                let n=this.tabParm[this.activeTab].rpt.data;
                if (!n.hasOwnProperty('importid') || n.fid=="") return;
                this.$confirm(this.$t('report_this_operation_will_delete_all_data_do_you_want_to_continue'),this.$t('tips_prompt'),{confirmButtonText:this.$t('button_sure'),cancelButtonText:this.$t('button_cancel'),type:'warning'
                }).then( async()=>{
                    let res = await jUtil.deleteImportData(n);
                    if (res.code==1) {
                        //this.$refs.mydialog.showDialog({text:this.$t('report_report_deleted_successfully')});
                        this.$message.success(this.$t('report_report_deleted_successfully'));
                        _this.removeTab(_this.activeTab);
                        _this.$emit("uphis",{},n.importid);
                    }
                    else {
                        this.$refs.mydialog.showDialog({type:"error",text:this.$t('report_deletion_failed')+'!('+res.message+")",info:res.error});
                    }
                }).catch(()=>{});
            },

            //deleteimportDetail
            async  deleteImportDetail(id,callback) {
                let _this=this;
                let n=this.tabParm[this.activeTab].rpt.data;
                n.i_id=id;
                let res = await jUtil.deleteImportDetail(n);
                if (res.code==1) {
                    this.$message.success(this.$t('report_data_deletion_successful'));
                }
                else {
                    this.$refs.mydialog.showDialog({type:"error",text:this.$t('report_deletion_failed')+'!('+res.message+")",info:res.error});
                }
                callback(res);
            },
            async  loadReportData(n,reload){
                let _this=this;
                let res={};
                if (n.data==null) return -1;
                let loading =this.$loading({lock:false,text:this.$t('tips_loading_data_please_wait'),background:"rgba(0,0,0,0.5)"});
                if (n.data.code==null)
                   res = await jUtil.loadReportData(n.data);
                else
                    res = await jUtil.loadReportView(n.data);
                if (res.code==1) {
                    loading.close();
                    this.parmLoad=1;
                    if (reload==undefined) _this.tabDataLoaded(n,{argData:res.argdata,parm:res.set.parm,parmData:res.parmdata,rpt:n});
                    _this.$refs[n.name][0].viewSpread(res,n);

                }
                else
                {  loading.close();
                    this.$refs.mydialog.showDialog({type:"error",text:this.$t('report_report_retrieval_failed')+"!("+res.message+")",info:res.error});
                    if (reload==undefined) _this.tabDataLoaded(n,{});
                }
                // loading.close();
            },



            openImportFile() {

                this.$refs.upload_file.dispatchEvent(new MouseEvent('click'));
            },


            importFile() {

                let file = document.getElementById("upload_file").files[0];
                let fileName = file.name;
                let index = fileName.lastIndexOf('.');
                let fileExt = fileName.substr(index + 1).toLowerCase();
                if (fileExt === 'xlsx' ) {
                    this.importFromExcel(file);
                } else {
                    this.$refs.mydialog.showDialog({type:"error",text:this.$t('report_invalid_file'),info:this.$t('report_please_select_an_excel_template_file')+'xlsx'});
                }
                $("#upload_file").val("");
            },


            //上传EXCEL
            importFromExcel(file){
                let _this=this;
                this.$refs[this.activeTab][0].excelIo.open(file, (json) => {
                    let workbookObj = json;
                    _this.$refs[this.activeTab][0].spread.fromJSON(workbookObj);
                    _this.importFileName=file.name;

                }, function (e) {
                    let err="";
                    if (e.errorCode === 0 || e.errorCode === 1) {
                        err="invalidImportFile";
                    } else if (e.errorCode === 2) {
                        err='passwordError';
                    } else if (e.errorCode === 3) {
                        err=e.toString();
                    }
                    _this.$refs.mydialog.showDialog({text:this.$t('report_file_opening_failed')+"!("+err+")"});

                });
            },

        }

    }


</script>

<style  lang="scss" >
    .ul_tools {
        display: flex;
        float: left;
    }

    .spviewhome {
        margin-top: 0px;
        height:100% ;
        width: 100%;
    }

    .tool_bar {
        position: relative;
        float: left;
        //height: 40px;
        width:100%;
        border-bottom: 1px solid #d5d7da;
        z-index: 1000;
    }

    .icon-button {
        margin-top:5px;
        padding: 2px 0px;
        color: #4b7476;
        outline: none;
        cursor: pointer;
        text-align: center;
        line-height:36px;

    }
    .icon-menu {
        color: #257e6c;
        outline: none;
        font-size: 24px;
    }
    .icon-button:hover {
        background: #d3d3d3;

    }
    .font-button {
        margin-top:5px;
        padding: 5px 5px;
        color: #016277;
        font-size: 14pt;
        outline: none;
        cursor: pointer;
        text-align: center;
        line-height:36px;

    }
    .font-checked {
        background: #f6e3ac;

    }
    .font-button:hover {
        background: #babdbf;
        pointer-events:auto;
    }
    .font-disable {
        opacity: 0.5;
        pointer-events:none;
    }
    .zhedie-button {
        width:6px;
        margin:0px;
        padding: 11px 0px ;
        color: #4a8587;
        background: #f2f2f2;
        font-size: 16px;
        outline: none;
        cursor: pointer;
        text-align: center;
        line-height:38px;
    }
    .zhedie-button:hover {
        background: #f6e3ac;
        pointer-events:auto;
    }
    .dp-left-button {
        padding-right: 0;
        margin-right: 0px;
        text-align: center;
        line-height:36px;
        position: relative;
        color: #016277;
        outline: none;
        cursor: pointer;
        height: 36px;
        width:20px;
    }

    .dp-left-button:hover {
        background: #d3d3d3
    }
    .dp-right-button {
        text-align: center;
        line-height:36px;
        font-size: 15px;
        position: relative;
        color: #016277;
        outline: none;
        cursor: pointer;
        height: 36px;
        width:15px;
    }
    .dp-right-button:hover {
        background: #d3d3d3
    }
    .select_item{
        font-size: 9px;
    }
    .font-disable {
        opacity: 0.5;
        pointer-events:none;
    }
    .content {
        position: relative;
        margin: 0;
        padding: 0;
        width: 100%;
        height: calc(100% - 40px);
        overflow: hidden;


        .sp_tab__view {
            flex: 1;
            margin-top: 2;
            position: relative;
            width: 100%;
            height: calc(100% );
            overflow: hidden;


            .el-tabs-card {
                margin: 0;
                padding: 0;
                width: 100%;
                height: 36px;

                /deep/ .el-tabs__header {
                    height: 36px;
                }

            }


            .el-tabs--border-card > .el-tabs__content {
                margin: 0;
                padding: 0px;
                border: 0px solid #267b87;
                overflow: hidden;
            }

        }
    }
        .component {
            margin-top: 1;
            padding: 0px;
            height: 100%;
            border: 1px solid #bca795;
            overflow: hidden;
        }
    .parm_item
    {   padding: 0px 0px;
        margin: 0px;
        height: 32px;
        position: relative;
        float: left;
        width: 180px;
    }
</style>